module.exports = __webpack_public_path__ + "main/images/learnmore/download-in-app-store.eb1f83c8eb612a4e0b2da16eefbb03d1.svg";